import { gql } from '@apollo/client';

export const GET_USER_PROVIDERS = gql`
  query GetUserProviders($auth0Id: String) {
    GetUserProviders(auth0Id: $auth0Id)
  }
`;

export const UPDATE_USER_DISPLAY_NAME = gql`
  mutation UpdateUserMetadata($input: UpdateUserMetadataInput!) {
    UpdateUserMetadata(input: $input)
  }
`;

export const CHECK_IMAGE_EXISTENCE = gql`
  query CheckReviewImageExistence($content_id: String!) {
    CheckReviewImageExistence(content_id: $content_id)
  }
`;
